// Polyfill
import "intersection-observer";
import objectFitImages from "object-fit-images";
import closetPolyfill from "./lib/closet.polyfill";
objectFitImages();
closetPolyfill();

// Libraly
import Loading from "./lib/Loading";
// import $ from "jquery";
// import Swiper from "swiper";
import ScrollObserver from "./lib/ScrollObserver";
// import { dropdown } from './lib/dropdown';
import { inview } from "./lib/inview";
import { topMvSlider } from "./lib/topSlider";
import { changeBg } from "./lib/changeBg";
import loopimg from "./lib/loopimg";
import toggleMenu from "./lib/toggleMenu";
import { getFeed } from "./lib/getFeed";
import { instaFeed } from "./lib/instaFeed";
import { loadAnimation } from "./lib/loadAnimation";

// new Toggle(".js-drawer");
getFeed();
new Loading();
topMvSlider();
changeBg();
loopimg();
toggleMenu();
instaFeed();
loadAnimation();

(() => {
  window.addEventListener("DOMContentLoaded", () => {
    // scroll
    // ----------------------------
    const fadeAnimation = new ScrollObserver(".js-scroll", inview, {
      once: true,
      rootMargin: "0% 0% 0px",
    });

    // scroll
    // ----------------------------
    const pagetopBtn = document.querySelector("#page-top");
    pagetopBtn.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  });
})();
